import { render, staticRenderFns } from "./DirectManagerDashboardRelation.vue?vue&type=template&id=4cf74afc&"
import script from "./DirectManagerDashboardRelation.vue?vue&type=script&lang=js&"
export * from "./DirectManagerDashboardRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports